module.exports = {
  title: 'Overline',
  context: {
    text: 'Overline',
    tag: 'span',
    class: 'overline'
  },
}